import { render, staticRenderFns } from "./upgrade.vue?vue&type=template&id=5539901f&scoped=true"
import script from "./upgrade.vue?vue&type=script&lang=js"
export * from "./upgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5539901f",
  null
  
)

export default component.exports